// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"Connect_socialLink__2UASj","circleFrame":"Connect_circleFrame__1ah6e"};